<header
  class="top-nav relative z-50 bg-white shadow-sm border-b border-gray-200"
>
  <div
    class="mx-auto flex h-16 max-w-screen-2xl items-center gap-6 px-4 sm:px-6 lg:px-8"
  >
    <div>
      <h2 class="max-sm:text-xs text-sm font-bold">
        Ministry of Petroleum and Mineral Resources
      </h2>
      <p class="max-sm:text-xs text-sm text-ppdms-text-1">
        Anambra State Government
      </p>
    </div>
    <!-- ── Right actions ──────────────────────────────── -->
    <div class="ml-auto flex items-center gap-2">
      <!-- Notification bell -->
      <!-- <button
        type="button"
        class="relative rounded-full p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
        title="Notifications"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-5 w-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
          />
        </svg>
        <span
          class="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"
        ></span>
      </button> -->

      <!-- Divider -->
      <div class="hidden sm:block h-6 w-px bg-gray-200"></div>

      <!-- User menu -->
      <div class="relative">
        <button
          type="button"
          (click)="toggleDropdown('__user__')"
          class="flex items-center gap-2.5 rounded-lg px-2 py-1.5 transition-colors hover:bg-gray-100"
        >
          <div
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white shadow-sm"
            [class.bg-gradient-to-br]="true"
            [class.from-ppdms-primary]="accountType === 'USER'"
            [class.to-ppdms-secondary]="accountType === 'USER'"
            [class.from-ppdms-secondary]="accountType === 'ADMIN'"
            [class.to-ppdms-primary]="accountType === 'ADMIN'"
          >
            {{ username.charAt(0).toUpperCase() }}
          </div>
          <div class="hidden text-left md:block">
            <p class="text-xs font-semibold leading-none text-gray-800">
              {{ username }}
            </p>
            <p class="mt-0.5 text-[11px] leading-none text-gray-400">
              {{ accountType === "ADMIN" ? "Administrator" : "Standard User" }}
            </p>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2.5"
            stroke="currentColor"
            class="hidden md:block h-3 w-3 text-gray-400 transition-transform duration-200"
            [class.rotate-180]="isDropdownOpen('__user__')"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </button>

        <!-- User dropdown -->
        @if (isDropdownOpen("__user__")) {
          <div
            class="dropdown-panel absolute right-0 top-full mt-1.5 w-48 rounded-xl border border-gray-100 bg-white py-1.5 shadow-lg ring-1 ring-black/5"
          >
            <a
              (click)="onMyProfile()"
              class="flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-4 w-4 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                />
              </svg>
              My Profile
            </a>
            <!-- @if (accountType === "ADMIN") {
              <a
                routerLink="/admin/settings/general"
                (click)="closeDropdowns()"
                class="flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="h-4 w-4 text-gray-400"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                Settings
              </a>
            } -->
            <!-- <div class="my-1 border-t border-gray-100"></div> -->
            <button
              type="button"
              (click)="logout()"
              class="flex w-full items-center gap-2.5 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-4 w-4"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                />
              </svg>
              Sign out
            </button>
          </div>
        }
      </div>

      <!-- Mobile hamburger -->
      <button
        type="button"
        (click)="toggleMobile()"
        class="lg:hidden rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
        title="Toggle menu"
      >
        @if (mobileOpen) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            class="h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            class="h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        }
      </button>
    </div>
  </div>

  <!-- ── Mobile menu ────────────────────────────────── -->
  <div
    class="mobile-menu lg:hidden border-t border-gray-200 bg-white transition-all duration-100 overflow-hidden"
    [class]="!mobileOpen ? 'h-0 p-0' : 'h-fit px-4 py-3'"
  >
    <nav class="flex flex-col gap-0.5">
      @for (item of items; track item.label) {
        @if (item.children?.length) {
          <div>
            <button
              type="button"
              (click)="toggleDropdown(item.label)"
              class="flex w-full items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
            >
              @if (item.icon) {
                <app-iconify-icon [icon]="item.icon"></app-iconify-icon>
              }
              <span class="flex-1 text-left">{{ item.label }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                class="h-3.5 w-3.5 text-gray-400 transition-transform duration-200"
                [class.rotate-180]="isDropdownOpen(item.label)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            </button>

            @if (isDropdownOpen(item.label)) {
              <div
                class="ml-4 mt-0.5 flex flex-col gap-0.5 border-l-2 border-gray-100 pl-3"
              >
                @for (child of item.children; track child.label) {
                  <a
                    [routerLink]="child.route"
                    routerLinkActive="text-blue-600 font-semibold"
                    [routerLinkActiveOptions]="{
                      exact: child.exact ?? false,
                    }"
                    (click)="closeDropdowns(); mobileOpen = false"
                    class="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                  >
                    <span
                      class="h-1 w-1 shrink-0 rounded-full bg-gray-400"
                    ></span>
                    {{ child.label }}
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <a
            [routerLink]="item.route"
            routerLinkActive="text-blue-600 bg-blue-50 font-semibold"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
            (click)="mobileOpen = false"
            class="flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
          >
            @if (item.icon) {
              <app-iconify-icon [icon]="item.icon"></app-iconify-icon>
            }
            {{ item.label }}
          </a>
        }
      }
    </nav>
  </div>
</header>

@if (showMyProfileModal) {
  <app-my-profile-modal (close)="showMyProfileModal = false">
  </app-my-profile-modal>
}
